import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';

export const DEFAULT_MAT_TAB_CONFIG = { animationDuration: '0' };
export const TOOLTIP_POSITION = 'above';

export const MATERIAL_PROVIDERS = [
  { provide: MAT_TABS_CONFIG, useValue: DEFAULT_MAT_TAB_CONFIG },
  {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: { position: TOOLTIP_POSITION },
  },
];
